import {
  Avatar,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";

const RenderReviewCard = ({ item }) => {
  console.log(item, "itemitemitem");

  const [showAllReview, setShowAllReview] = useState(false);

  const maxCharacters = 100;

  return (
    <Card
      sx={{
        minWidth: 300,
        maxWidth: 400,
        height: "auto",
        padding: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar
              src={item?.userID?.image}
              alt={item?.userID?.username}
              sx={{ width: 60, height: 60 }}
            />
          </Grid>
          <Grid item={true}>
            <Typography variant="h6" fontSize={14}>
              {item?.userID?.username}
            </Typography>
            {/* <Typography variant="body2" color="text.secondary">
              {item?.userID?.email}
            </Typography> */}
          </Grid>
        </Grid>
        <Typography variant="body2" color="text.secondary" sx={{ marginY: 2 }}>
          {showAllReview
            ? item?.feedback
            : `${item?.feedback?.slice(0, maxCharacters)}...`}{" "}
          {/* Show truncated text */}
        </Typography>
        {item?.feedback?.length > maxCharacters && (
          <Button
            variant="text"
            color="primary"
            onClick={() => setShowAllReview(!showAllReview)}
            size="small"
            sx={{ textTransform: "none" }}
          >
            {showAllReview ? "Read Less" : "Read More"}
          </Button>
        )}
        <Typography variant="body2" color="primary" sx={{ marginTop: 1 }}>
          ⭐ {item.rating} |{" "}
          {moment(item.createdAt).format("YYYY/MM/DD hh:mm A")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default RenderReviewCard;
